import { useStore } from '../../../models'
import { GameModal, GameModalKinds, LayerType } from '../../../models/game/game-modals'
import { useGameBottomModal } from './useGameBottomModals'

export const useShortcuts = () => {
  const {
    game: { pushGameModals, setIsCallOptionsModalOpen },
    communication: { isLocalUserJoined }
  } = useStore()

  const { handleOpenCallOptions } = useGameBottomModal()

  const startJoinCall = async () => {
    setIsCallOptionsModalOpen(true)
    if (isLocalUserJoined) {
      handleOpenCallOptions()
    } else {
      pushGameModals(
        GameModal.create({
          kind: GameModalKinds.options,
          props: {},
          layerType: LayerType.alert // noop
        })
      )
    }
  }

  return {
    handleVideo: startJoinCall
  }
}
